import styled, { css } from 'styled-components'

import { Grid as UnstyledGrid, Column as UnstyledColumn } from 'components/Grid'
import { Text, Link as UnstyledLink } from '@sketch/components'

import { breakpoint } from '@sketch/global-styles'

export const StyledLink = styled(UnstyledLink)`
  display: block;
  margin-top: 24px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const FormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
`

export const DimText = styled(Text).attrs({
  textStyle: 'copy.quaternary.standard.E',
})`
  max-width: 400px;
  margin: 24px auto 0;
  text-align: center;

  ${StyledLink} {
    display: inline-block;
    margin: 0;
    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  }
`

export const TextSignUp = styled.p`
  margin-top: 32px;
  font-size: ${({ theme }) => theme.fontSizes.E};
  text-align: center;
`

export const Line = styled.div`
  width: 100%;
  margin-top: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.A};
`

export const StyledColumn = styled(UnstyledColumn)``

export const StyledGrid = styled(UnstyledGrid)`
  padding: 0 16px;

  ${breakpoint('xs')`
    padding: 0 32px;
  `}

  ${StyledColumn} {
    max-width: 448px;
  }
`

export const Title = styled.h1(
  ({ theme }) => css`
    margin: 0 0 16px 0;
    font-size: ${theme.fontSizes.I};
    line-height: 1;
  `
)

export const Subtitle = styled.p`
  margin-bottom: 24px;
`

export const Feature = styled.div`
  display: flex;
  align-items: top;
  margin-bottom: 12px;
  line-height: 1.4;
`

export const FeatureImg = styled.img`
  margin-right: 8px;
  width: 24px;
  height: 24px;
`

export const OperatingSystemWarning = styled(Text).attrs({
  textStyle: 'copy.quaternary.standard.C',
})`
  text-align: center;
  margin-top: 12px;
`

export const RelatedContentTitle = styled.h1(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.F};
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.colors.foreground.secondary.A};
    margin: 0;
  `
)

export const RelatedContentDescription = styled.p(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.E};
    font-weight: ${theme.fontWeights.regular};
    color: ${theme.colors.foreground.secondary.D};
    line-height: ${theme.lineHeights.E};
    margin: 4px 0 0 0;
  `
)

export const RelatedContentImg = styled.img(
  ({ theme }) => css`
    width: 64px;
    height: 64px;
    margin-right: 16px;
    border-radius: ${({ theme }) => theme.radii.xlarge};
  `
)

export const RelatedContentLink = styled(UnstyledLink)`
  display: flex;
  flex-direction: row;
  margin-top: 28px;
  white-space: break-spaces;

  :hover {
    ${RelatedContentTitle} {
      color: ${({ theme }) => theme.colors.foreground.secondary.C};
      text-decoration: underline;
    }
  }
`

export const FullWidthImage = styled.img`
  width: 100%;
  margin-top: 28px;
`
